import * as React from "react";
import { IconPresentationProps } from "@insite/mobius/Icon/Icon";

const Pinterest: React.FC<IconPresentationProps> = props => {
    return (
        <svg xmlns="http://www.w3.org/2000/svg" width="59" height="58" viewBox="0 0 59 58">
            <g id="Pin" transform="translate(-9811.309 -6042.478)">
                <g
                    id="Area_SIZE:MEDIUM_STATE:DEFAULT_STYLE:STYLE2_"
                    data-name="Area [SIZE:MEDIUM][STATE:DEFAULT][STYLE:STYLE2]"
                    transform="translate(9811.309 6042.478)"
                    fill="none"
                    stroke="#fff"
                    stroke-width="2"
                >
                    <rect width="59" height="58" rx="29" stroke="none" />
                    <rect x="1" y="1" width="57" height="56" rx="28" fill="none" />
                </g>
                <path
                    id="social-pinterest-outline"
                    d="M15.76,2.25a13.51,13.51,0,1,0,13.51,13.51A13.511,13.511,0,0,0,15.76,2.25Zm8.19,21.7A11.605,11.605,0,0,1,12.9,26.985a8.341,8.341,0,0,0,.422-1.164c.169-.6.953-3.715.953-3.715a3.876,3.876,0,0,0,3.3,1.683c4.343,0,7.292-3.956,7.292-9.258,0-4.005-3.4-7.738-8.552-7.738-6.417,0-9.656,4.6-9.656,8.438,0,2.322.881,4.391,2.768,5.163a.464.464,0,0,0,.675-.338c.06-.235.211-.838.277-1.086a.662.662,0,0,0-.193-.754,3.905,3.905,0,0,1-.893-2.648A6.4,6.4,0,0,1,15.946,9.1c3.625,0,5.621,2.213,5.621,5.175,0,3.9-1.725,7.183-4.282,7.183a2.093,2.093,0,0,1-2.135-2.6c.4-1.713,1.194-3.558,1.194-4.8a1.807,1.807,0,0,0-1.821-2.027c-1.448,0-2.606,1.5-2.606,3.5a5.158,5.158,0,0,0,.434,2.135s-1.475,6.267-1.735,7.365a9.391,9.391,0,0,0-.175,1.013,11.575,11.575,0,1,1,13.51-2.093Z"
                    transform="translate(9825.001 6055.717)"
                    fill="#fff"
                />
            </g>
        </svg>
    );
};

export default React.memo(Pinterest);
